// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container Principal */
.fc {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  --fc-button-bg-color: #ffffff;
  --fc-button-border-color: #d9d9d9;
  --fc-button-text-color: rgba(0, 0, 0, 0.88);
  --fc-button-active-bg-color: #e6f4ff; /* Azul bem claro (padrão hover antd) */
  --fc-button-active-border-color: #1677ff;
  --fc-button-active-text-color: #1677ff;
  --fc-today-bg-color: #f0f7ff; /* Fundo do dia atual mais suave */
  padding: 10px 0px;
}

/* Toolbar (Botões de Navegação) */
.fc .fc-toolbar-title {
  font-size: 1.5em;
  font-weight: 600;
  color: #1f1f1f;
  text-transform: capitalize; /* "fevereiro de 2026" */
}

.fc .fc-button {
  border-radius: 6px;
  padding: 4px 15px;
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.fc .fc-button-primary {
  background-color: var(--fc-button-bg-color);
  border-color: var(--fc-button-border-color);
  color: var(--fc-button-text-color);
}

.fc .fc-button-primary:hover {
  color: #4096ff;
  border-color: #4096ff;
  background-color: #fff;
}

.fc .fc-button-primary:focus {
  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
}

/* Botão Ativo (Mês, Semana, Lista selecionado) */
.fc .fc-button-primary:not(:disabled).fc-button-active,
.fc .fc-button-primary:not(:disabled):active {
  background-color: var(--fc-button-active-bg-color);
  border-color: var(--fc-button-active-border-color);
  color: var(--fc-button-active-text-color);
  font-weight: 500;
}

/* Cabeçalho dos Dias */
.fc-col-header-cell {
  background: #fafafa;
  padding: 8px 0;
}

.fc-col-header-cell-cushion {
  color: #595959;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
  text-decoration: none !important;
}

/* Células do Dia */
.fc-daygrid-day-top {
  flex-direction: row; /* Data à esquerda */
  padding: 8px;
}

.fc-daygrid-day-number {
  color: #1f1f1f;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none !important;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.3s;
}

.fc-daygrid-day-number:hover {
  background-color: #f5f5f5;
}

/* Estilo do dia de HOJE */
.fc-day-today .fc-daygrid-day-number {
  background-color: #1677ff;
  color: #fff;
}

/* Eventos */
.fc-daygrid-event {
  border-radius: 4px;
  margin-top: 2px;
  border: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.fc-daygrid-event:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.12);
  z-index: 5;
}

/* Remove a cor de fundo padrão para usarmos a nossa no render */
.fc-h-event {
  background-color: transparent;
  border: none;
}

/* Visualização em Lista */
.fc-list-event:hover td {
  background-color: #e6f4ff !important;
}

.fc-list-day-cushion {
  background-color: #f5f5f5 !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Schedules/styles.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,uGAAuG;EACvG,6BAA6B;EAC7B,iCAAiC;EACjC,2CAA2C;EAC3C,oCAAoC,EAAE,uCAAuC;EAC7E,wCAAwC;EACxC,sCAAsC;EACtC,4BAA4B,EAAE,kCAAkC;EAChE,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,0BAA0B,EAAE,wBAAwB;AACtD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uCAAuC;EACvC,yDAAyD;AAC3D;;AAEA;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,iDAAiD;AACjD;;EAEE,kDAAkD;EAClD,kDAAkD;EAClD,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,mBAAmB,EAAE,oBAAoB;EACzC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,UAAU;AACZ;;AAEA,gEAAgE;AAChE;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* Container Principal */\n.fc {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  --fc-button-bg-color: #ffffff;\n  --fc-button-border-color: #d9d9d9;\n  --fc-button-text-color: rgba(0, 0, 0, 0.88);\n  --fc-button-active-bg-color: #e6f4ff; /* Azul bem claro (padrão hover antd) */\n  --fc-button-active-border-color: #1677ff;\n  --fc-button-active-text-color: #1677ff;\n  --fc-today-bg-color: #f0f7ff; /* Fundo do dia atual mais suave */\n  padding: 10px 0px;\n}\n\n/* Toolbar (Botões de Navegação) */\n.fc .fc-toolbar-title {\n  font-size: 1.5em;\n  font-weight: 600;\n  color: #1f1f1f;\n  text-transform: capitalize; /* \"fevereiro de 2026\" */\n}\n\n.fc .fc-button {\n  border-radius: 6px;\n  padding: 4px 15px;\n  font-size: 14px;\n  font-weight: 400;\n  text-transform: capitalize;\n  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n.fc .fc-button-primary {\n  background-color: var(--fc-button-bg-color);\n  border-color: var(--fc-button-border-color);\n  color: var(--fc-button-text-color);\n}\n\n.fc .fc-button-primary:hover {\n  color: #4096ff;\n  border-color: #4096ff;\n  background-color: #fff;\n}\n\n.fc .fc-button-primary:focus {\n  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);\n}\n\n/* Botão Ativo (Mês, Semana, Lista selecionado) */\n.fc .fc-button-primary:not(:disabled).fc-button-active,\n.fc .fc-button-primary:not(:disabled):active {\n  background-color: var(--fc-button-active-bg-color);\n  border-color: var(--fc-button-active-border-color);\n  color: var(--fc-button-active-text-color);\n  font-weight: 500;\n}\n\n/* Cabeçalho dos Dias */\n.fc-col-header-cell {\n  background: #fafafa;\n  padding: 8px 0;\n}\n\n.fc-col-header-cell-cushion {\n  color: #595959;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 12px;\n  text-decoration: none !important;\n}\n\n/* Células do Dia */\n.fc-daygrid-day-top {\n  flex-direction: row; /* Data à esquerda */\n  padding: 8px;\n}\n\n.fc-daygrid-day-number {\n  color: #1f1f1f;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none !important;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background 0.3s;\n}\n\n.fc-daygrid-day-number:hover {\n  background-color: #f5f5f5;\n}\n\n/* Estilo do dia de HOJE */\n.fc-day-today .fc-daygrid-day-number {\n  background-color: #1677ff;\n  color: #fff;\n}\n\n/* Eventos */\n.fc-daygrid-event {\n  border-radius: 4px;\n  margin-top: 2px;\n  border: none;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n  transition: transform 0.2s, box-shadow 0.2s;\n  cursor: pointer;\n}\n\n.fc-daygrid-event:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.12);\n  z-index: 5;\n}\n\n/* Remove a cor de fundo padrão para usarmos a nossa no render */\n.fc-h-event {\n  background-color: transparent;\n  border: none;\n}\n\n/* Visualização em Lista */\n.fc-list-event:hover td {\n  background-color: #e6f4ff !important;\n}\n\n.fc-list-day-cushion {\n  background-color: #f5f5f5 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
